export default __webpack_public_path__ + "static/media/banana.287d6a56.png";